
import { Options, Vue } from "vue-class-component";
import Input from "@/app/ui/components/input/index.vue";
import { LocationController } from "@/app/ui/controllers/LocationController";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";

@Options({
  components: {
    Input
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (!this.openSuccess && !this.isError) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      LocationController.setOpenModalSuccess(false);
      next();
    }
  }
})
export default class Edit extends Vue {
  created() {
    this.getDetailCountryData(this.$route.params.id);
  }

  goBack() {
    this.$router.back();
  }

  fetchCountryData() {
    this.getDetailCountryData(this.$route.params.id);
  }

  id() {
    return this.$route.params.id;
  }

  item = {
    status: "Active"
  };

  isDisabled = true;

  // Detail data
  getDetailCountryData(id: any) {
    return LocationController.getDetailCountry({ id });
  }

  createdAt = "";
  createdBy = "";
  updateAt = "";
  updateBy = "";

  dataDetail() {
    const detail = LocationController.countryDetail;
    this.createdAt = formatDate(detail.createdAt);
    this.createdBy = detail.createdBy;
    this.updateAt =
      detail.updateAt === "0001-01-01T00:00:00Z"
        ? formatDate(detail.createdAt)
        : formatDate(detail.updateAt);
    this.updateBy = detail.updatedBy;
    return detail;
  }

  // Toggle Route
  openRoute = false;
  onOpenRoute() {
    if (this.isRoute) {
      this.openRoute = true;
    } else {
      LocationController.setRoute(!this.isRoute);
    }
  }
  onCloseRoute() {
    this.openRoute = false;
  }
  get isRoute() {
    return LocationController.isRoute;
  }
  changeRoute() {
    LocationController.setRoute(!this.isRoute);
    this.openRoute = false;
    this.messageSuccess = `Lokasi “${this.dataDetail().name} - ${
      this.dataDetail().code
    }”`;
  }
  cacheRoute() {
    return LocationController.cacheRoute;
  }
  // Modal Success
  messageSuccess = "";
  get openSuccess() {
    return LocationController.openModalSuccess;
  }
  onCloseSuccess() {
    this.$router.push(`/network/location/country/${this.$route.params.id}`);
  }

  // Save data
  openSave() {
    return LocationController.openModal;
  }
  onOpenSave() {
    LocationController.setOpenModal(true);
  }
  onCloseSave() {
    LocationController.setOpenModal(false);
  }

  _onEdit() {
    LocationController._onEditCountry({
      id: Number(this.id()),
      isActive: this.isRoute ? "active" : "inactive"
    });
  }

  // Close when changed
  isEditTerminated = false;
  newPath = "";
  answer = false;

  get hasChanged() {
    return this.cacheRoute() !== this.isRoute;
  }

  onOpenClosePage(to: any) {
    this.isEditTerminated = true;
    this.newPath = to.path;
  }

  handlerClose() {
    this.isEditTerminated = false;
    this.answer = true;
    this.$router.push(this.newPath);
  }

  handlerCancelClose() {
    this.answer = false;
    this.isEditTerminated = false;
  }

  //Error
  get isError() {
    return LocationController.isError;
  }

  //Error Cause
  get errorCause() {
    return LocationController.isErrorCauseCountry;
  }

  handleErrorClose() {
    LocationController.handleError();
    this.getDetailCountryData(this.$route.params.id);
  }

  //Loading
  public get isLoading() {
    return LocationController.isLoadingDetailCountry;
  }
}
